export default function Footer() {
  const go = (id: string) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  return (
    <footer className="bg-secondary-200">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-disc-fill text-xl"></i>
              </span>
              <span className="font-heading text-2xl tracking-wide text-foreground-950">53吃瓜</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              一个轻松唠嗑、靠谱追更的瓜友聚集地。看新瓜、追话题、投稿发帖、和瓜友一起唠嗑，随时跟进最新动态不落伍。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"><i className="ri-wechat-line"></i></span>
              <span className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"><i className="ri-weibo-line"></i></span>
              <span className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"><i className="ri-qq-line"></i></span>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-bold text-foreground-950">快速导航</h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-foreground-700">
              <li><a href="#home" onClick={(e) => { e.preventDefault(); go('home'); }} className="cursor-pointer hover:text-primary-700">首页</a></li>
              <li><a href="#hot" onClick={(e) => { e.preventDefault(); go('hot'); }} className="cursor-pointer hover:text-primary-700">今日热榜</a></li>
              <li><a href="#feed" onClick={(e) => { e.preventDefault(); go('feed'); }} className="cursor-pointer hover:text-primary-700">最新投稿</a></li>
              <li><a href="#faq" onClick={(e) => { e.preventDefault(); go('faq'); }} className="cursor-pointer hover:text-primary-700">常见问题</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-bold text-foreground-950">热门栏目</h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-foreground-700">
              <li><a href="#feed" onClick={(e) => { e.preventDefault(); go('feed'); }} className="cursor-pointer hover:text-primary-700">娱乐新瓜</a></li>
              <li><a href="#feed" onClick={(e) => { e.preventDefault(); go('feed'); }} className="cursor-pointer hover:text-primary-700">热剧追更</a></li>
              <li><a href="#feed" onClick={(e) => { e.preventDefault(); go('feed'); }} className="cursor-pointer hover:text-primary-700">综艺名场面</a></li>
              <li><a href="#feed" onClick={(e) => { e.preventDefault(); go('feed'); }} className="cursor-pointer hover:text-primary-700">生活唠嗑</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-bold text-foreground-950">加入唠嗑</h4>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">有想分享的新瓜？马上投稿，让更多瓜友看到你的观点。</p>
            <a
              href="#post"
              onClick={(e) => { e.preventDefault(); go('post'); }}
              className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-edit-2-line"></i>
              我要投稿
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-foreground-950/10 pt-6 text-xs text-foreground-700 sm:flex-row">
          <p>© {new Date().getFullYear()} 53吃瓜 · 看瓜追更 投稿唠嗑</p>
          <div className="flex items-center gap-4">
            <span className="cursor-pointer hover:text-primary-700">关于我们</span>
            <span className="cursor-pointer hover:text-primary-700">社区规范</span>
            <span className="cursor-pointer hover:text-primary-700">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}